module.exports = __webpack_public_path__ + "static/img/102420.ef44e897.png";